<label class="add-edit-header">{{!rule.id? 'ADD' : 'EDIT'}} RULE</label>
<div
  class="x-sign"
  inlineSVG="/assets/icons/x-close-pop.svg"
  (click)="close.emit()"
></div>

<ichannel-input
  class="name-input"
  [label]="'Name'"
  [value]="rule.name"
  (output)="rule.name=$event"
></ichannel-input>
<ichannel-input
  class="rule-input"
  [label]="'Set Rule'"
  [value]="rule.format"
  (output)="rule.format=$event"
></ichannel-input>
<ichannel-input
  class="id-format-input"
  [label]="'Id Format'"
  [value]="rule.idFormat"
  (output)="rule.idFormat=$event"
></ichannel-input>

<div class="select-rule-type-container">
  <div class="icn-radio-button">
    <input
      type="radio"
      id="mainVideoRuleRadioButton"
      name="radiogroupBatchRule"
      [checked]="rule.type === 1"
    />
    <label for="mainVideoRuleRadioButton" (click)="rule.type = 1"
      >Main Video Rule</label
    ><br />
    <div class="radio-separator"></div>
    <input
      type="radio"
      id="AudioRuleRadioButton"
      name="radiogroupBatchRule"
      [checked]="rule.type === 2"
    />
    <label for="AudioRuleRadioButton" (click)="rule.type = 2">Audio Rule</label
    ><br />
    <div class="radio-separator"></div>
    <input
      type="radio"
      id="SubsRuleRadioButton"
      name="radiogroupBatchRule"
      [checked]="rule.type === 3"
    />
    <label for="SubsRuleRadioButton" (click)="rule.type = 3"
      >Subtitles Rule</label
    ><br />
    <div class="radio-separator"></div>
    <input
      type="radio"
      id="PackShotRuleRadioButton"
      name="radiogroupBatchRule"
      [checked]="rule.type === 4"
    />
    <label for="PackShotRuleRadioButton" (click)="rule.type = 4"
      >Packshot Rule</label
    ><br />
    <input
      type="radio"
      id="TrailerRuleRadioButton"
      name="radiogroupBatchRule"
      [checked]="rule.type === 5"
    />
    <label for="TrailerRuleRadioButton" (click)="rule.type = 5"
      >Trailer Rule</label
    ><br />
  </div>
</div>

<div class="options-container">
  <div class="options" *ngIf="rule.type === 2">
    <div class="options-control">
      <label class="icn-label">AUDIO LANGUAGE:</label>
      <icn-dropdown [position]="bottom" [(selectedValue)]="rule.audioLanguage">
        <icn-dropdown-item
          *ngFor="let lang of languages"
          [title]="lang.name"
          [value]="lang.code"
        ></icn-dropdown-item>
      </icn-dropdown>
    </div>
  </div>

  <div class="options" *ngIf="rule.type === 3">
    <div class="options-control">
      <label class="icn-label">SUBS LANGUAGE:</label>
      <icn-dropdown
        [position]="bottom"
        [(selectedValue)]="rule.subtitlesLanguage"
      >
        <icn-dropdown-item
          *ngFor="let lang of languages"
          [title]="lang.name"
          [value]="lang.code"
        ></icn-dropdown-item>
      </icn-dropdown>
    </div>

    <div class="options-control">
      <label class="icn-label">FPS:</label>
      <icn-dropdown [position]="bottom" [(selectedValue)]="rule.subtitlesFps">
        <icn-dropdown-item title="23.976" [value]="23.976"></icn-dropdown-item>
        <icn-dropdown-item title="24" [value]="24"></icn-dropdown-item>
        <icn-dropdown-item
          title="25 - Default for Israel & Europe"
          [value]="25"
        ></icn-dropdown-item>
        <icn-dropdown-item title="29.97" [value]="29.97"></icn-dropdown-item>
        <icn-dropdown-item
          title="30 - Default for the US & Japan"
          [value]="30"
        ></icn-dropdown-item>
        <icn-dropdown-item title="50" [value]="50"></icn-dropdown-item>
        <icn-dropdown-item title="59.94" [value]="59.94"></icn-dropdown-item>
        <icn-dropdown-item title="60" [value]="60"></icn-dropdown-item>
      </icn-dropdown>
    </div>

    <div class="options-control">
      <label class="icn-label">OFFSET:</label>
      <div class="input-range-container">
        <label class="offset-label">{{rule.subtitlesOffset}}</label>
        <input
          type="range"
          [(ngModel)]="rule.subtitlesOffset"
          min="-10"
          max="10"
          step="0.01"
        />
      </div>
    </div>
    <div class="select-rule-type-container">
      <div class="icn-radio-button">
        <input
          type="radio"
          id="affectAllRelatedSubtitles"
          name="subtitleRuleOption"
          [checked]="!detachRelatedSubtitles"
        />
        <label
          for="affectAllRelatedSubtitles"
          (click)="detachRelatedSubtitles = false"
          >Affect all related subtitles</label
        ><br />
        <input
          type="radio"
          id="detachRelatedSubtitles"
          name="subtitleRuleOption"
          [checked]="detachRelatedSubtitles"
        />
        <label
          for="detachRelatedSubtitles"
          (click)="detachRelatedSubtitles = true"
          >Detach related subtitles</label
        ><br />
      </div>
    </div>
  </div>
</div>
<footer>
  <ichannel-button
    [label]="'Save'"
    [theme]="'DARK'"
    (click)="onSave()"
  ></ichannel-button>
</footer>
